import { render, staticRenderFns } from "./empty-button.vue?vue&type=template&id=76e08e98&scoped=true"
import script from "./empty-button.vue?vue&type=script&lang=js"
export * from "./empty-button.vue?vue&type=script&lang=js"
import style0 from "./empty-button.vue?vue&type=style&index=0&id=76e08e98&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e08e98",
  null
  
)

export default component.exports